module.exports = __webpack_public_path__ + "static/media/mask-inverted.182bcf0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/mask-inverted.png
// module id = 128
// module chunks = 0